/*
 * @FilePath: \uni-preset-vue-vite\src\plugins\setupPinia.js
 * @Date: 2022-10-01 21:32:03
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-15 16:59:42
 * @Description:
 */

import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { model, registerModel, uniStorage } from './model'

function setupPinia(app) {
  const modalPinia = createPinia()

  // 先注册持久化插件
  modalPinia.use(
    createPersistedState({
      storage: uniStorage
    })
  )

  app.use(modalPinia)
  // 确保在 pinia 实例创建后再注册 store
  registerModel()

  return app
}

export { setupPinia, model, registerModel, uniStorage }
